import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { fetcher } from '@dashboard/services/request';
import Button from '@dashboard/components/Button';
import AuthLayout from '@/dashboard/layouts/AuthLayout';
import { useToast } from '@dashboard/context/ToastContext';

const AccountVerifyEmailChange = () => {
  const { emailChangeToken } = useParams();
  const history = useHistory();
  const { emitToast } = useToast();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        setLoading(true);

        const response = await fetcher(`/user/verify-email-change/${emailChangeToken}`, null, {
          method: 'POST',
        });

        if (response) {
          setSuccess(true);
          emitToast({
            title: 'Email updated',
            description: 'Your email has been successfully updated!',
            type: 'success',
          });
          setTimeout(() => {
            history.push('/dashboard/account/profile');
          }, 3000);
        } else {
          setError('This link is invalid or expired. Please try again or contact support.');
        }
      } catch (err) {
        setError(
          err.message || 'This link is invalid or expired. Please try again or contact support.',
        );
      } finally {
        setLoading(false);
      }
    };

    if (emailChangeToken) {
      verifyEmail();
    }
  }, [emailChangeToken]);

  return (
    <AuthLayout>
      <div className="py-2">
        <div className="text-center m-auto">
          {loading && <h1 className="text-xl mb-2">Verifying your email address..</h1>}

          {error && (
            <div>
              <h1 className="text-xl mb-2">{`Couldn't verify email address`}</h1>
              <p>{error}</p>
              <div className="mt-4">
                <Button appearance="primary" to={'/dashboard/account/profile'}>
                  Go to profile
                </Button>
              </div>
            </div>
          )}

          {success && (
            <div>
              <h1 className="text-xl mb-2">Your email address has been verified.</h1>

              <p>
                You will be redirected to your profile in 3 seconds. If you are not redirected,
                please click the button below.
              </p>

              <div className="mt-4">
                <Button appearance="primary" to={'/dashboard/account/profile'}>
                  Go to profile
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </AuthLayout>
  );
};

export default AccountVerifyEmailChange;
